export const PAYMENT_FORM_FIELD_IDS = {
    PAYVAULT_CARD_NUMBER: 'payvault-card-number-field',
    PAYVAULT_EXPIRY_DATE: 'payvault-expiry-date-field',
    OWNER_NAME: 'ownerName',
    EXPIRY_DATE: 'expiryDate',
    EXPIRE_MONTH: 'expireMonth',
    EXPIRE_YEAR: 'expireYear',
} as const;
